'use client';
import * as DS from '@aurorasolar/ds';
import { formatDate } from 'date-fns';
import Image from 'next/image';

export type Props = {
  author?: string | null;
  date?: string | null;
  image?: {
    altText?: string | null;
    sourceUrl?: string | null;
  };
};

export default function CreditBlock({ author, image, date }: Props) {
  const imageUrl = image?.sourceUrl ? new URL(image.sourceUrl).pathname : '';

  return (
    <DS.Flex
      alignItems={{ _: '', md: 'center' }}
      flexDirection={{ _: 'column', md: 'row' }}
      flexShrink={1}
      gap="4"
      py="4"
    >
      {imageUrl ? (
        <DS.Box h={64} overflow="hidden" position="relative" w={64}>
          <Image
            alt={author ?? 'author image'}
            fill
            sizes="64px"
            src={imageUrl}
            style={{ objectFit: 'cover', objectPosition: 'top' }}
          />
        </DS.Box>
      ) : null}
      <DS.Flex flexDirection="column" flexShrink={1} gap="2">
        <DS.Text text="h3">{author ? `By ${author}` : 'Author Unknown'}</DS.Text>
        <DS.Text color="uiHelperCopy" text="body16">
          {date ? formatDate(new Date(date), 'MMMM do, yyyy') : ''}
        </DS.Text>
      </DS.Flex>
    </DS.Flex>
  );
}
